const AVATAR_COLOR_PALETTE: string[] = [
  // Existing colors
  '#E06055',
  '#F06292',
  '#BA68C8',
  '#9575CD',
  '#7986CB',
  '#5E97F6',
  '#4FC3F7',
  '#4DD0E1',
  '#4DB6AC',
  '#57BB8A',
  '#9CCC65',
  '#D4E157',
  '#FDD835',
  '#F6BF26',
  '#FFA726',
  '#FF8A65',
  '#C2C2C2',
  '#90A4AE',
  '#A1887F',
  '#A3A3A3',
  '#AEB5DF',
  '#B39DDB',
  '#80DEEA',
  '#BCAAA4',
  '#AED581',
  '#F57C00',

  // New colors
  '#D32F2F',
  '#C2185B',
  '#7B1FA2',
  '#512DA8',
  '#303F9F',
  '#1976D2',
  '#0288D1',
  '#0097A7',
  '#00796B',
  '#388E3C',
  '#689F38',
  '#AFB42B',
  '#FBC02D',
  '#FFA000',
  '#F57F17',
  '#E65100',
  '#BF360C',
  '#6D4C41',
  '#8D6E63',
  '#616161',
  '#455A64',
  '#546E7A',
  '#37474F'
];

export default AVATAR_COLOR_PALETTE;
